import React, { useRef, useEffect } from "react";
import { observer } from "mobx-react-lite";
import useStore from "../../store";
// import posterImg from "../../assets/img/tu2.jpg";
import play from "../../assets/img/play.png";
import x from "../../assets/img/x.png";
import videoBg from "../../assets/img/videoBg.png";

import "./index.scss";

const Video = (props) => {
  const videoRef = useRef();
  const playRef = useRef();
  const xRef = useRef();
  const posterRef = useRef();

  // const source =
  //   "https://vodpub6.v.news.cn/yqfbzx-original/20221006/202210069a1ecc0cab5a49808494bd40fdf7b6a0_701107764a974bfc8ba5f209cff1b039.mp4";

  const clickHandler = () => {
    videoRef.current.play();
    playRef.current.style.display = "none";
    xRef.current.style.display = "block";
    posterRef.current.style.display = "none";
  };

  const xHandler = () => {
    videoRef.current.pause();
    playRef.current.style.display = "block";
    xRef.current.style.display = "none";
    posterRef.current.style.display = "block";
  };

  const playHandler = () => {
    videoRef.current.play();
    playRef.current.style.display = "none";
    xRef.current.style.display = "block";
    posterRef.current.style.display = "none";
  };

  const { playStore } = useStore();

  // console.log(playStore.play);

  useEffect(() => {
    if (playStore.play === "000") {
      xHandler();
    } else {
      playHandler();
    }
  }, [playStore.play]);

  return (
    <div className="videoBox">
      <img className="videoBg" src={videoBg} alt="" />
      <video
        ref={videoRef}
        className="myVideo"
        poster={props.videoObj.posterImg}
        preload="auto"
        controls
        playsInline={true}
        x5-playsinline={"true"}
        webkit-playsinline="true"
        src={props.videoObj.src}
      ></video>
      <img
        ref={posterRef}
        className="Poster"
        src={props.videoObj.posterImg}
        alt="播放按钮"
        onClick={clickHandler}
      />
      <img
        ref={playRef}
        className="Play"
        src={play}
        alt="poster"
        onClick={playHandler}
      />
      <img ref={xRef} className="x" src={x} alt="x" onClick={xHandler} />
    </div>
  );
};

export default observer(Video);
